import * as types from "../constants";

const initialState = {
    videos: [],
    video: null,
    loading: false,
    error: null
}

const videoReducer = (state = initialState, action)=>{
    const {type, payload} = action;

    switch(type){
        case types.FETCHING_VIDEOS:
            return {
                ...state, 
                loading: true
            };
        case types.FETCH_VIDEOS_SUCCESS:
            return {
                ...state,
                videos: payload,
                loading: false,
                error: null
            };
        case types.FETCH_VIDEOS_FAILURE:
            return {
                ...state,
                loading: false,
                error: payload,
                videos: [],
            };
        case types.FETCH_VIDEO_SUCCESS:
            return {
                ...state,
                loading: false,
                error: null,
                video: payload
            };
        case types.FETCH_VIDEOS_FAILURE:
            return {
                ...state,
                loading: false,
                error: payload,
                video: null
            }

        default: 
            return state;

    }
}

export default videoReducer;